import React, { useState } from 'react';
import { Input, Icon } from '@teamleader/ui';
import { IconVisibleOffSmallOutline, IconVisibleSmallOutline } from '@teamleader/ui-icons';

import styles from './styles.css';

const PasswordInput = (props?: Record<string, any>) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handlePasswordVisiblityToggle = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <Input
      type={isPasswordVisible ? 'text' : 'password'}
      suffix={
        <Icon
          color="neutral"
          tint="darkest"
          onClick={handlePasswordVisiblityToggle}
          marginRight={2}
          className={styles['password-visibility-toggle']}
        >
          {isPasswordVisible ? <IconVisibleOffSmallOutline /> : <IconVisibleSmallOutline />}
        </Icon>
      }
      {...props}
    />
  );
};

export default PasswordInput;
